import { Component } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { TCITenantSelectorType } from "@tci/common";
import { BaseAppDetailMenuComponentInput, BaseAppDetailMenuComponentOutput } from "../../../ng-app-details-menu";
import { AbstractTCITenantComponent } from "../../../../ng-tenant/tci-tenant-component";

@Component({
    selector: TCITenantSelectorType.TCI_MENU_APP_MONITORING_METRICS_COLLECTION.toString(),
    template: "<div>FLOW METRICS COLLECTION</div>"
})
export class BaseFlowMetricsCollectionComponent<E, I extends BaseAppDetailMenuComponentInput,
    O extends BaseAppDetailMenuComponentOutput<E>>
    extends AbstractTCITenantComponent<E, I, O> {
    constructor(protected translate: TranslateService) {
        super();
    }
}
